<template>
  <app-card :fill-height="false">
    <div class="card-body user-widget">
      <div class="user-widget-head">
        <div class="user-avatar-wrapper">
          <div class="user-avatar text-uppercase">{{clientName.charAt(0) }}</div>
        </div>
        <h4>{{ clientName }}</h4>
        <span class="badge success">Active</span>
      </div>
      <div class="user-info-navigation">
        <ul>
          <li><router-link to="/profile-change-auth">Profile Settings</router-link></li>
          <li><router-link to="/profile-settings-scheme">Layout Settings</router-link></li>
        </ul>
      </div>
    </div>
  </app-card>
</template>

<script>
export default {
  name: 'userInfo',
  computed: {
    clientName () {
      return this.$store.state.auth.accountParams.client_name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/profile/settings/userInfo.vue